module.exports = __webpack_public_path__ + "assets/img/xiaobu-logo.666e405e.png";